import { FC } from "react";
import { Image } from "@/components/Image/Image";
import { Link } from "@/components/Link/Link";
import { pagesPath } from "@/lib/$path";

export const Banner: FC = () => {
  return (
    <Link href={pagesPath.$url()} className="h-fit" target="_blank">
      <Image
        src="/images/kdotdev/banner.svg"
        alt="kdot Logo"
        width={360}
        height={640}
        className="border border-solid border-gray-pale"
        style={{ objectFit: "cover", width: "100%", height: "auto" }}
      />
    </Link>
  );
};
